import React, { Component, Fragment } from 'react';

import Button from '../../artzu-ui/src/Button';
import TextField from '../../artzu-ui/src/TextField';

import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';

import SubmitImage from './SubmitImage';
import PreviewImage from './PreviewImage';
import Footer from './FooterFixed';

import ScrollLock from 'react-scrolllock';
import EncourageScroll from '../EncourageScroll';

class UploadLicense extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: null,
      licenseNum: props.currentUser.driversLicenseNumber || '',
      src: '',
      errors: '',
      licenseError: '',
      loading: false,
    };
  }

  updateSrc = src => this.setState({ src });

  toggleLoaded = () => this.setState({ loading: !this.state.loading });

  checkErrors = () => {
    const { licenseNum } = this.state;

    if (!licenseNum.match(/^[A-Z]\d{4}(\-?)\d{5}(\-?)\d{5}$/)) {
      this.setState({ licenseError: licenseNum ? 'Not a valid format.' : 'This is required.' });
    } else {
      const formattedNum = licenseNum.split('-').join('');
      const licenseNumber = [formattedNum.slice(0, 5), formattedNum.slice(5, 10), formattedNum.slice(10)].join('-');
      this.setState({
        licenseError: '',
        licenseNum: licenseNumber,
      });
      this.updateUser(licenseNumber);
      return true;
    }
  };

  updateUser = number => {
    this.props.client
      .mutate({
        mutation: UPDATE_USER,
        variables: {
          userFields: {
            driversLicenseNumber: number,
          },
        },
      })
      .then(() => {
        this.props.refetch();
      });
  };

  onNextClick = () => {
    if (this.checkErrors()) this.props.incrementStep();
  };

  onBackClick = () => this.props.decrementStep();

  editDashes = input => {
    let numbers = [];
    input.split('').forEach(char => {
      if (char !== '-') {
        numbers.push(char.toUpperCase());
      }
    });
    numbers = numbers.join('');
    let returnVal = '';

    returnVal += numbers[5] ? `${numbers.slice(0, 5)}-` : numbers.slice(0);
    returnVal += numbers[10] ? `${numbers.slice(5, 10)}-` : numbers.slice(5);
    returnVal += numbers.slice(10);

    return returnVal;
  };

  render() {
    const { currentUser, currentStep, refetch, title } = this.props;
    const { src, licenseError, licenseNum, loading } = this.state;

    return (
      <Fragment>
        <ScrollLock>
          <EncourageScroll className="apply__license">
            <div className="apply__license--container">
              <div className="apply__body--title"> {title}</div>
              <div className="apply__license--content">
                <div>
                  <div>
                    {' '}
                    Please upload a photo of your <b>Ontario full G license.</b>
                  </div>
                  <br />
                  <div>
                    {' '}
                    Text must be <b>clear</b> and <b>readable.</b>{' '}
                  </div>
                  <br />
                  <div> *Expired documents are not valid. </div>
                  <br />
                </div>
                <TextField
                  onChange={evt => this.setState({ licenseNum: evt.target.value })}
                  heading="Driver's License Number"
                  error={licenseError}
                  width="100%"
                  value={this.editDashes(licenseNum)}
                  placeholder="Enter driver's License number here"
                />
              </div>
              <div className="apply__license--upload">
                <PreviewImage
                  image={currentUser ? currentUser.driversLicenseImage : null}
                  src={src}
                  category="license"
                  loading={loading}
                />
                <div className="apply__license--buttons">
                  {currentUser.driversLicenseImage || src ? (
                    <Button
                      fullWidth
                      width="100%"
                      label="Edit Image"
                      onClick={() => {
                        const input = document.getElementById('edit_photo');
                        input.click();
                      }}
                    />
                  ) : null}
                  <div className="hide">
                    <Button label="Edit" />
                  </div>
                  <SubmitImage
                    toggleLoaded={this.toggleLoaded}
                    type="drivers_license_image"
                    refetch={refetch}
                    updateSrc={this.updateSrc}
                  />
                </div>
              </div>
            </div>
          </EncourageScroll>
        </ScrollLock>
        <Footer
          currentStep={currentStep}
          currentUser={currentUser}
          active={(currentUser.driversLicenseImage || src) && !loading}
          back
          label="Next"
          onNextClick={this.onNextClick}
          onBackClick={this.onBackClick}
        />
      </Fragment>
    );
  }
}

const UPDATE_USER = gql`
  mutation updateUser($userFields: UserAttributes!) {
    updateUser(userFields: $userFields) {
      errors {
        message
      }
    }
  }
`;

export default withApollo(UploadLicense);



// WEBPACK FOOTER //
// ./src/components/TorontoApply/UploadLicense.js